import { render, staticRenderFns } from "./scoreCompelete.vue?vue&type=template&id=be112b74"
import script from "./scoreCompelete.vue?vue&type=script&lang=js"
export * from "./scoreCompelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports